import React from 'react';
import { getRandomWidth } from '../helpers/get-random-width';

const SkeletonLines = ({ lines = 1 }) => {
  if (lines > 0) {
    return new Array(lines).fill(<div />).map((_, index) => (
      <span className="ws-ui-text-skeleton__line-container" key={`item-${index + Math.random()}`}>
        &nbsp;
        <span
          className="ws-ui-text-skeleton__line"
          style={{
            // @ts-ignore TS(2322): Type 'string | false' is not assignable to type 'M... Remove this comment to see the full error message
            maxWidth: lines !== 1 && getRandomWidth(),
          }}
        />
      </span>
    ));
  }
  return null;
};

export default SkeletonLines;
